import { create } from "zustand";
import type { IPayoutTransactionMinimal } from "../types/models/payout-transaction.modals.types";

interface IWalletTranasactionsStore {
	transactions: Array<IPayoutTransactionMinimal> | null;
	setTransactions: (transactions: Array<IPayoutTransactionMinimal>) => void;
	removeTransactionById: (id: string) => void;
}

const useWalletTranasactionsStore = create<IWalletTranasactionsStore>(
	(set) => ({
		transactions: null,
		setTransactions: (transactions) => {
			set((data) => ({ ...data, transactions }));
		},
		removeTransactionById: (id: string) => {
			set((data) => {
				return {
					...data,
					transactions: data.transactions?.filter((i) => i.id !== id),
				};
			});
		},
	}),
);

export default useWalletTranasactionsStore;
